import { render, staticRenderFns } from "./MoisturizeUsageSelectionModal.vue?vue&type=template&id=2601609c&scoped=true"
import script from "./MoisturizeUsageSelectionModal.vue?vue&type=script&lang=js"
export * from "./MoisturizeUsageSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./MoisturizeUsageSelectionModal.vue?vue&type=style&index=0&id=2601609c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601609c",
  null
  
)

export default component.exports